import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { emptyAlertMsg } from "../../Redux/actions";
import AlertModel from "./AlertModel";
let ToastMessage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const alertMsg = useSelector((state) => state.toastReducer.alertMsg);
  const closeAlert = () => {
    dispatch(emptyAlertMsg());
  };
  return alertMsg && alertMsg !== null ? (
    <AlertModel
      title={alertMsg?.title}
      text={alertMsg?.text}
      open={true}
      closeModal={closeAlert}
    />
  ) : null;
};
export default ToastMessage;
